import PropTypes from 'prop-types';
import { Fragment } from 'react';

import withBindProps from 'core/hocs/withBindProps';
import withTheme from 'core/hocs/withTheme';

import SmartArrow from 'core/components/Icon/SmartArrow';
import ArrowRegularSharp from 'core/components/Icon/ArrowRegularSharp.svg';

import themePropTypes from 'core/utils/prop-types/theme';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

function Arrows(props) {
  const {
    side,
    theme: {
      controls: {
        paginatron: {
          icon: {
            arrow: {
              size: arrowSize,
            },
          },
        },
      },
    },
  } = props;

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .arrow
          width ${arrowSize}
          height ${arrowSize}
      `}</style>
    </scope>
  );

  return (
    <Fragment>
      <SmartArrow
        icon={withBindProps({ className: scope.wrapClassNames('arrow') })(ArrowRegularSharp)}
        direction={side}
      />
      <scope.styles />
    </Fragment>
  );
}

Arrows.propTypes = {
  /** Направление отображения стрелок (см. SmartArrow) */
  side: PropTypes.oneOf(['up', 'down', 'left', 'right']),
  /** @ignore */
  theme: themePropTypes(`
    {
      controls: {
        paginatron: {
          icon: {
            arrow: {
              size
            },
          }
        },
      }
    }
 `),
};

const ArrowsWithHOCs = withTheme(Arrows);
ArrowsWithHOCs.displayName = 'Arrows';

export { Arrows as StorybookComponent };
export default ArrowsWithHOCs;
